import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App.jsx"
import { MarkLogicProvider } from "ml-fasttrack"

ReactDOM.createRoot(document.getElementById("root")).render(
  <MarkLogicProvider
    scheme="http"
    host="localhost"
    port="4001"
    options="search-options"
    auth={{ username: "fasttrack-getting-started-user", password: "password" }}
  >
    <App />
  </MarkLogicProvider>
)
